const initialVolveConfiguration = {
    volveConfigurationLists: [],
    volveConfigurationById: null,
    volveConfigurationStatus: [],
    volveConfigurationPermissions: {},
    changedVolveConfigurationStatus : [],
    loadingVolveConfiguration: false,
    errorsVolveConfiguration: {}
}

const  volveConfigurationReducer = (state = initialVolveConfiguration, action) => {
    switch (action.type) {
        case "GET_VOLVE_CONFIGURATION_LIST_PENDING":
        case "ADD_VOLVE_CONFIGURATION_PENDING":   
        case "UPDATE_VOLVE_CONFIGURATION_PENDING":
        case "UPDATE_VOLVE_CONFIGURATION_STATUS_PENDING":
        case "DELETE_VOLVE_CONFIGURATION_PENDING":
        case "GET_VOLVE_CONFIGURATION_BY_ID_PENDING":
            return { ...state, loadingVolveConfiguration: true };

        case "GET_VOLVE_CONFIGURATION_LIST_FULFILLED":
            return {
                ...state,
                loadingVolveConfiguration: false,
                volveConfigurationLists: action.payload,
                volveConfigurationCount: action.volveConfigurationCount,
                volveConfigurationPermissions: action.permissions,
            };
           
        case "ADD_VOLVE_CONFIGURATION_FULFILLED":
            return {
                ...state,
                loadingVolveConfiguration: false,
                changedVolveConfigurationStatus: action.payload,
            };
            
        case "UPDATE_VOLVE_CONFIGURATION_FULFILLED":
            return {
                ...state,
                loadingVolveConfiguration: false,
                changedVolveConfigurationStatus: action.payload,
            };
            
        case "UPDATE_VOLVE_CONFIGURATION_STATUS_FULFILLED":
            return {
                ...state,
                loadingVolveConfiguration: false,
                changedVolveConfigurationStatus: action.payload,
            };
            
        case "DELETE_VOLVE_CONFIGURATION_FULFILLED":
            return {
                ...state,
                loadingVolveConfiguration: false,
                changedVolveConfigurationStatus: action.payload,
            };
            
        case "GET_VOLVE_CONFIGURATION_BY_ID_FULFILLED": 
            return {
                ...state,
                loadingVolveConfiguration: false,
                volveConfigurationById: action.payload,
            };
            
        case "GET_VOLVE_CONFIGURATION_LIST_REJECTED":
            return {
                ...state,
                loadingVolveConfiguration: false,
                errorsVolveConfiguration: action.payload,
            };
            case "RESET_DELETE_VOLVE_CONFIGURATION_STATUS":
                return {
                    ...state,
                   loadingVolveConfiguration: false,
                   errorsVolveConfiguration: {},
                   changedVolveConfigurationStatus: [],
                };

        case "ADD_VOLVE_CONFIGURATION_REJECTED":
        case "UPDATE_VOLVE_CONFIGURATION_REJECTED":
        case "UPDATE_VOLVE_CONFIGURATION_STATUS_REJECTED":
        case "DELETE_VOLVE_CONFIGURATION_REJECTED":
        case "GET_VOLVE_CONFIGURATION_BY_ID_REJECTED":
            return {
                ...state,
                loadingVolveConfiguration: false,
                errorsVolveConfiguration: action.payload,
            };
        default:
            return state;

    }
  }
  export default volveConfigurationReducer;